import { render, staticRenderFns } from "./importDB.vue?vue&type=template&id=cd194122&"
import script from "./importDB.vue?vue&type=script&lang=js&"
export * from "./importDB.vue?vue&type=script&lang=js&"
import style0 from "./importDB.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports